import html from "./ConsentReviewStep.html"
import SignaturePad from "signature_pad"
import "../SurveyReactComponent"
import { getConsentMarkdownAsForm, getSignatureDate, getTypedNameFormItems } from "../../../components/Survey/Util/consent";
import { renderFormStepToHtml } from "../../../components/Survey/Components/FormStepToHtml/FormStepToHtml";
import { buildConsentHtml, buildConsentReviewFrameHtml } from "../../../components/Survey/Util/consentReviewHtml";
import { participantConfirm } from "../../../components/MyDataHelps/ConfirmDialog/participantConfirm";
import { followsPreviewSwitch, rendersDark, stampSchemeOnFrame } from "../../../helpers/surveyColorScheme";

var module = angular.module("ResearchKitApplicationModule");

module.directive("consentReviewStep",
	["$window", "$timeout", function ($window, $timeout) {
		return {
			template: html,
			replace: false,
			restrict: "E",
			scope: {
				"stepManager": "="
			},
			link: function (scope, iElement, iAttrs, controller) {
				var resetIframeHeight = function () {
					var position = $(iElement).find(".review-frame-wrapper").position();
					var footerHeight = $(iElement).find(".toolbar").outerHeight();
					var targetHeight = $(iElement).parents(".current-survey-content").height() - position.top - footerHeight;
					$(iElement).find(".review-frame-wrapper").height(targetHeight);
				}

				scope.$watch("stepManager", function () {
					if (scope.stepManager.surveyManager.getMode() != "Design") {
						$timeout(resetIframeHeight);
					}
				});

				if (scope.stepManager.surveyManager.getMode() != "Design") {
					$($window).on("resize", resetIframeHeight);
				}
			}
		};
	}]
);

module.controller("consentReviewStepController", ["$scope", "$sce", "$element", "$translate", "$timeout",
	function ($scope, $sce, $element, $translate, $timeout) {

		var self = this;

		$scope.$on('nextStackStep', function () {
			if ($scope.stepManager.consentReviewStepIndex == $scope.stepManager.getPages().length - 1) {
				$scope.stepManager.consentReviewStepIndex = 0;
			} else {
				$scope.stepManager.consentReviewStepIndex++;
			}
		});

		$scope.$on('previousStackStep', function () {
			if ($scope.stepManager.consentReviewStepIndex == 0) {
				$scope.stepManager.consentReviewStepIndex = $scope.stepManager.getPages().length - 1;
			} else {
				$scope.stepManager.consentReviewStepIndex--;
			}
		});

		$scope.trustAsHtml = function (value) { return $sce.trustAsHtml(value); };

		$scope.$watch('stepManager.step', function (newValue) {
			if (newValue !== null) {
				$scope.initalize();
			}
		})

		if ($scope.stepManager && followsPreviewSwitch($scope.stepManager)) {
			$scope.$watch(function () { return rendersDark($element[0]); }, function () {
				if ($element.find(".review-frame")[0]) {
					stampSchemeOnFrame($element[0], self.getContentDocument());
				}
			});
		}

		$scope.$watch('stepManager.consentReviewStepIndex', function (newValue) {
			var currentPage = $scope.stepManager.currentPage();
			var pageSubStepIdentifiers = {
				"Review": "consent_agreement",
				"Name": "consent_name",
				"Signature": "consent_signature"
			};
			if (pageSubStepIdentifiers[currentPage]) {
				$scope.stepManager.surveyManager.trackSubStepViewed($scope.stepManager.step.identifier, pageSubStepIdentifiers[currentPage], newValue);
			}
		});

		$scope.getNameTitle = function () {
			var defaultTitle = $translate.instant("consent-step-title");
			return $scope.stepManager.step.title || defaultTitle;
		};

		$scope.initalize = function () {
			$scope.canAgree = true;
			if ($scope.stepManager.step.requiresScrollToBottom) {
				$scope.canAgree = false;
				var checkReviewFrameScroll = self.checkReviewFrameScroll;
				var checkMarkdownScroll = self.checkMarkdownScroll;

				if(!$scope.stepManager.step.consentMarkdown){
					var reviewFrame = $element.find(".review-frame");
					reviewFrame.on('load', function () {
						var reviewFrameDoc = self.getContentDocument();
						if (reviewFrameDoc) {
							reviewFrameDoc.addEventListener('scroll', checkReviewFrameScroll);
						}
						// check initially
						checkReviewFrameScroll();
					});
				} else {
					var markdownContainer = $element.find(".consent-markdown-container");
					markdownContainer[0].addEventListener('scroll', () => $scope.$apply(() => checkMarkdownScroll()));
					// reset scroll to top before checking so canAgree isn't enabled prematurely
					$timeout(() => {
						markdownContainer.scrollTop(0);
						checkMarkdownScroll();
					});
				}

			}

			if (!$scope.stepManager.step.consentMarkdown) {
				var content = $scope.trustAsHtml($scope.stepManager.displayedConsentHtml());
				var reviewFrameDoc = self.getContentDocument(reviewFrame);
				reviewFrameDoc.write(content);
				reviewFrameDoc.close();
				// Deferred because the Try It Out modal stamps its scheme after the steps initialize.
				$timeout(function () { stampSchemeOnFrame($element[0], reviewFrameDoc); });
				$(reviewFrameDoc).scrollTop(0);
			} else {
				var content = $element.find(".consent-markdown-container");
				$timeout(() => content.scrollTop(0));
			}

			var signatureCanvas = $element.find('.signature-line');
			self.signaturePad = new SignaturePad(signatureCanvas[0]);
			self.signaturePad.addEventListener("endStroke", () => {
				$scope.$apply(function () {
					$scope.stepManager.updateSignatureImage(self.signaturePad.toDataURL());
				});
			});
		}

		$scope.tryAgree = function () {
			if ($scope.stepManager.step.reasonForConsent) {
				participantConfirm($scope.stepManager.step.reasonForConsent, { okTextKey: 'global-agree-button-text', translate: $translate }).then((confirmed) => {
					if (confirmed) { $scope.$apply(() => { $scope.stepManager.agree(); }); }
				});
			} else {
				$scope.stepManager.agree();
			}
		}

		$scope.clearSignature = function () {
			self.signaturePad.clear();
			$scope.stepManager.updateSignatureImage(null);
		}

		self.$onDestroy = function () {
			var contentDoc = self.getContentDocument();
			if (contentDoc) {
				contentDoc.removeEventListener("scroll", self.checkReviewFrameScroll);
			}
		}

		self.checkReviewFrameScroll = function () {
			var reviewFrame = $element.find(".review-frame");
			var contentDocument = self.getContentDocument(reviewFrame);
			if (($(contentDocument).scrollTop() + reviewFrame.outerHeight()) >= $(contentDocument.body).outerHeight()) {
				$scope.$apply(function () {
					$scope.canAgree = true;
				});
			}
		}

		self.checkMarkdownScroll = function () {
			var content = $element.find(".consent-markdown-container");
			if(content[0].scrollHeight === 0) {
				// Content not loaded.
				return;
			}
			if(content.scrollTop() + content.outerHeight() + 1 >= content[0].scrollHeight) {
				$scope.canAgree = true;
			}
		}

		self.getContentDocument = function (reviewFrame) {
			if (!reviewFrame) {
				reviewFrame = $element.find(".review-frame");
			}
			var reviewFrameDoc;
			if (reviewFrame[0].contentDocument) {
				reviewFrameDoc = reviewFrame[0].contentDocument;
			}
			else if (reviewFrame[0].contentWindow) {
				reviewFrameDoc = reviewFrame[0].contentWindow.document;
			}
			return reviewFrameDoc;
		}

		$scope.nameFormItems = function () {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }

			return getTypedNameFormItems({
				"first-name-label": $translate.instant("first-name-label"),
				"last-name-label": $translate.instant("last-name-label"),
				"required-field-placeholder": $translate.instant("required-field-placeholder")
			});
		}

		$scope.nameChildResults = function () {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }
			let signatureResult = $scope.stepManager.getChildResult(signature.identifier);

			return [
				{
					Identifier: "FirstName",
					Answers: [signatureResult?.Signature?.GivenName || ""]
				},
				{
					Identifier: "LastName",
					Answers: [signatureResult?.Signature?.FamilyName || ""]
				}
			]
		}

		$scope.onNameResultChange = function (result) {
			let signature = $scope.stepManager.signature();
			if (!signature || !signature.requiresName) { return []; }
			let signatureResult = $scope.stepManager.getChildResult(signature.identifier);
			if (!signatureResult) { return []; }

			$scope.$apply(function () {
				if (result.Identifier == "FirstName") {
					signatureResult.Signature.GivenName = result.Answers[0];
				}
				else if (result.Identifier == "LastName") {
					signatureResult.Signature.FamilyName = result.Answers[0];
				}
				$scope.stepManager.resultDidChange();
			});
		}
	}
]);

module.factory("ConsentReviewStepManager", ["$translate", "StepManager", function ($translate, StepManager) {
	function ConsentReviewStepManager(step, surveyManager) {
		StepManager.call(this, step, surveyManager);
		this.consentReviewStepIndex = 0;
	}
	ConsentReviewStepManager.prototype = Object.create(StepManager.prototype);

	ConsentReviewStepManager.prototype.initializeResults = function (previousResult) {
		StepManager.prototype.initializeResults.call(this, previousResult);
		var signature = this.signature();
		if (!signature) {
			this.childResults = [{
				Identifier: "NoSignature",
				Type: "ConsentSignatureResult",
				StartDate: this.presentedDate,
				Signature: {
					Identifier: "NoSignature",
					GivenName: "",
					FamilyName: "",
					PDFNameLineLabel: this.step.pdfNameLineLabel,
					PDFSignatureLineLabel: this.step.pdfSignatureLineLabel,
				}
			}];
		} else {
			this.childResults = [{
				Identifier: signature.identifier,
				Type: "ConsentSignatureResult",
				StartDate: this.presentedDate,
				Signature: {
					Identifier: signature.identifier,
					GivenName: signature.givenName,
					FamilyName: signature.familyName,
					Title: signature.title,
					PDFNameLineLabel: this.step.pdfNameLineLabel,
					PDFSignatureLineLabel: this.step.pdfSignatureLineLabel,
				}
			}];
		}
		if (this.step.autoAgree) {
			this.childResults[0].Consented = true;
		}
	}

	ConsentReviewStepManager.prototype.hasEnteredName = function () {
		if (this.signature()) {
			var result = this.getChildResult(this.signature().identifier);
			var givenName = result.Signature.GivenName;
			var familyName = result.Signature.FamilyName;
			if (givenName && givenName.length && familyName && familyName.length) {
				return true;
			}
		}
		return false;
	}

	ConsentReviewStepManager.prototype.disagree = function () {
		this.childResults[0].Consented = false;
		StepManager.prototype.continue.call(this);
	}

	ConsentReviewStepManager.prototype.agree = function () {
		this.childResults[0].Consented = true;
		this.continue();
	}

	function consentFrameHtml(manager, includeDarkSchemeStyles) {
		return buildConsentReviewFrameHtml(
			manager.consentDocument(),
			manager.surveyManager.template,
			manager.step,
			manager.getHideDefaultHeader(),
			includeDarkSchemeStyles
		);
	}

	ConsentReviewStepManager.prototype.displayedConsentHtml = function () {
		return consentFrameHtml(this, true);
	}

	// The signed record is shown later on white, in PDFs and coordinator views.
	ConsentReviewStepManager.prototype.storedConsentHtml = function () {
		return consentFrameHtml(this, false);
	}

	ConsentReviewStepManager.prototype.consentHTML = function (signatureResult, consentDocument) {
		return buildConsentHtml({
			reviewFrameHtml: this.storedConsentHtml(),
			signatureResult,
			consentDocument,
			signatureURL: this.signatureURL,
			strings: {
				consentPrintedNameLabel: (signatureLabel) => $translate.instant("consent-printed-name-label", { signatureLabel }),
				consentSignatureLabel: (signatureLabel) => $translate.instant("consent-signature-label", { signatureLabel }),
				consentDateLabel: $translate.instant("consent-date-label"),
			},
		});
	}

	ConsentReviewStepManager.prototype.isLastStep = function () {
		return StepManager.prototype.isLastStep.call(this) && (this.consentReviewStepIndex == this.getPages().length - 1);
	}

	ConsentReviewStepManager.prototype.getPages = function () {
		var signature = this.signature();
		var pages = ['Review'];
		if (this.step.autoAgree) {
			pages = [];
		}
		if (signature) {
			if (signature.requiresName) {
				pages.push('Name');
			}

			if (signature.requiresSignatureImage && !signature.bypassSignatureOnWeb) {
				pages.push('Signature')
			}
		}
		return pages;
	}

	ConsentReviewStepManager.prototype.continue = function () {
		if (this.consentReviewStepIndex == this.getPages().length - 1) {
			var signature = this.signature();
			var consentDocument = this.consentDocument();
			let result = this.getChildResult(signature ? signature.identifier : "NoSignature");
			result.Signature.Date = getSignatureDate(this.step.signatureDateFormat);
			if(!this.step.consentMarkdown) {
				result.Signature.ConsentDocumentContent = this.consentHTML(result.Signature, consentDocument);
			} else {
				const markdownForm = getConsentMarkdownAsForm(this.step.consentDocumentTitle, this.step.consentMarkdown);
				if(signature) {
					markdownForm.formItems.push({
						identifier: result.Identifier,
						type: 'FormItem',
						answerFormat: {
							...signature,
							type: 'SignatureAnswerFormat',
							signatureTitle: signature.title,
							signatureIdentifier: signature.identifier,
							pdfNameLineLabel: result.Signature.PDFNameLineLabel,
							pdfSignatureLineLabel: result.Signature.PDFSignatureLineLabel,
						}
					});
				}
				const results = signature ? [{
					Identifier: result.Identifier,
					Signature: {
						...result.Signature,
						HandwrittenSignatureBase64: this.signatureURL
					}
				}] : [];
				result.Signature.ConsentDocumentContent = renderFormStepToHtml(this.surveyManager.template, markdownForm, results, $translate) ;
			}
			
			result.Signature.ConsentDocumentTitle = consentDocument.title;
			StepManager.prototype.continue.call(this);
		} else {
			this.consentReviewStepIndex++;
		}
	}

	ConsentReviewStepManager.prototype.currentPage = function () {
		return this.getPages()[this.consentReviewStepIndex];
	}

	ConsentReviewStepManager.prototype.back = function () {
		if (this.consentReviewStepIndex == 0) {
			StepManager.prototype.back.call(this)
		} else {
			this.consentReviewStepIndex--;
		}
	}

	ConsentReviewStepManager.prototype.consentDocument = function () {
		var step = this.step;
		if (step.type == 'ConsentReviewStep') {
			return _.find(this.surveyManager.template.consentDocuments, function (document) { return document.title == step.consentDocumentTitle });
		} else {
			return {
				'type': 'ConsentDocument',
				'title': step.consentDocumentTitle,
				'sections': _.map(step.sections, function (section) {
					return {
						type: 'ConsentSection',
						sectionType: 'Custom',
						title: section['title'],
						htmlContent: section['content']
					};
				}),
				'signatures': [
					{
						'type': 'ConsentSignature',
						'identifier': 'Participant',
						'title': !step.signatureTitle ? 'Participant' : step.signatureTitle,
						'requiresName': step.requiresName,
						'requiresSignatureImage': step.requiresSignatureImage,
						'bypassSignatureOnWeb': step.bypassSignatureOnWeb
					}
				]
			};
		}
	}

	ConsentReviewStepManager.prototype.signature = function () {
		var consentDocument = this.consentDocument();
		if (!consentDocument) { return null; }
		var step = this.step;
		if (step.type == 'ConsentReviewStep') {
			return _.find(consentDocument.signatures, function (signature) { return signature.identifier == step.signatureIdentifier });
		}
		else {
			return _.first(consentDocument.signatures);
		}
	}

	ConsentReviewStepManager.prototype.updateSignatureImage = function (dataURL) {
		this.signatureURL = dataURL;
	}

	ConsentReviewStepManager.prototype.hasSignature = function () {
		return !!this.signatureURL;
	}

	ConsentReviewStepManager.prototype.getDisableDisagree = function () {
		if (this.step.type == 'ConsentReviewStep') {
			return this.step.disableDisagree;
		}
		else if (this.step.type === 'ConsentStep') {
			return !this.step.provideDisagree;
		}

		return true;
	}

	ConsentReviewStepManager.prototype.getHideDefaultHeader = function () {
		if (this.step.type == 'ConsentReviewStep') {
			return this.step.hideDefaultHeader;
		}
		return true;
	}

	ConsentReviewStepManager.prototype.canGoBack = function () {
		return StepManager.prototype.canGoBack.call(this) || this.consentReviewStepIndex > 0;
	}

	return ConsentReviewStepManager;
}]);